import IndexHtml from "static/message_generator/index";

const routes = [
    {
            name: "HTML",
            collapse: [
              {
                name: "index.html",
                route: "/index.html",
                component: IndexHtml,
              },
             
            ],
        },

        

]

export default routes;